import React from "react";
import OrderSummary from "./OrderSummary";
import { useRegistration } from "./RegistrationContext";

interface MobileOrderSummaryProps {
  selectedTicketType: any;
  quantity: number;
  eventDate: string;
  eventStartTime: string;
  eventEndTime: string;
  eventLocation: string;
  eventPrice: string;
}

const MobileOrderSummary: React.FC<MobileOrderSummaryProps> = ({
  selectedTicketType,
  quantity,
  eventDate,
  eventStartTime,
  eventEndTime,
  eventLocation,
  eventPrice,
}) => {
  const { showOrderSummary, setShowOrderSummary } = useRegistration();

  const toggleOrderSummary = () => {
    setShowOrderSummary(!showOrderSummary);
  };

  return (
    <div className="mb-4">
      <button
        onClick={toggleOrderSummary}
        className="w-full py-3 px-4 bg-white border rounded-md shadow-sm flex justify-between items-center"
      >
        <span className="font-medium">Order Summary</span>
        <span className="text-lg">{showOrderSummary ? "↑" : "↓"}</span>
      </button>

      {/* Mobile Order Summary (Collapsible) */}
      {showOrderSummary && (
        <div className="mt-2 mb-4">
          <OrderSummary
            eventPrice={eventPrice}
            selectedTicketType={selectedTicketType}
            quantity={quantity}
            eventDate={eventDate}
            eventStartTime={eventStartTime}
            eventEndTime={eventEndTime}
            eventLocation={eventLocation}
          />
        </div>
      )}
    </div>
  );
};

export default MobileOrderSummary;
